import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";
import {useCallback} from "react";
import {Chip, TableCell, TableRow, Typography} from "@material-ui/core";
import EmptyRow from "../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import SimpleTable from "../../../../../../../../shared/components/tables/simple-table/SimpleTable";
import {TABLE_SIZE_L, TABLE_SIZE_M, TABLE_SIZE_S} from "../OfferteHelper";
import {routePaths} from "../../../../../../../../shared/utils/constants/routePaths";
import {formatMissingData} from "../../../../../../../../shared/utils/formatDataUtils";
import {DigitalContractCardStyles} from "../../../../digital-contract-card/DigitalContractCardStyles";

const OfferteBulkTable = (props) => {
    const history = useHistory()
    const classes = DigitalContractCardStyles();

    const handleTableRowClick = useCallback((row) => {
        if (row.id && props.isClickable) {
            history.push(`${routePaths.EXTRA_SHARE}/${row.id}`)
        }
    }, [history, props.isClickable])

    const headCells = [
        {
            id: "bulk-nome",
            text: "nome",
            width: TABLE_SIZE_L
        },
        {
            id: "bulk-costo-attivazione",
            text: "costo attivazione",
            width: TABLE_SIZE_S
        },
        {
            id: "bulk-canone-unitario",
            text: "canone unitario",
            width: TABLE_SIZE_S
        },
        {
            id: "bulk-extra-share-riga-ordine",
            text: "ID R.O. EXTRA SHARE",
            width: TABLE_SIZE_M
        },
        {
            id: "bulk-numero-sim-associate",
            text: "numero sim associate",
            width: TABLE_SIZE_M
        },
        ...props.isClickable ? [{
            id: "bulk-condiviso-chip",
            text: "",
            width: TABLE_SIZE_S
        }] : []
    ]

    const tableRows = useCallback(() => {
        return (
            props.data && props.data.length > 0 ? props.data.map((row, idx) => (
                <TableRow key={`digital-contract-bulk-row-${idx}`}
                          hover={props.isClickable}
                          onClick={() => handleTableRowClick(row)}>
                    <TableCell component="th" scope="row">
                        <Typography variant="subtitle2">{row.itemDescription}</Typography>
                    </TableCell>
                    <TableCell align="left">
                        <Typography variant="subtitle2">{row.activationPriceDisplayValue}</Typography>
                    </TableCell>
                    <TableCell align="left">
                        <Typography variant="subtitle2">{row.monthlyPriceDisplayValue}</Typography>
                    </TableCell>
                    <TableCell align="left">
                        <Typography variant="subtitle2">{formatMissingData(row.rigaOrdine)}</Typography>
                    </TableCell>
                    <TableCell align="left">
                        <Typography variant="subtitle2">{row.numberOfSims}</Typography>
                    </TableCell>
                    {props.isClickable ? <TableCell align='left'>
                        {row.isCondiviso ? <Chip label='Condiviso'
                                                 className={classes.chipStyle}
                                                 size="small"/> : null}
                    </TableCell> : null}
                </TableRow>
            )) : <EmptyRow text='dato' colSpan={headCells.length}/>
        )
    }, [props.data, headCells.length, handleTableRowClick, props.isClickable, classes.chipStyle])

    return <SimpleTable
        headCells={headCells}
        tableRows={tableRows()}
        loading={props.loading}
    />
}

OfferteBulkTable.propTypes = {
    isClickable: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
}

export default OfferteBulkTable;
